import React from "react";
import { PatternFormat } from "react-number-format";
import { Field } from "formik";
import {InputContainer} from "styles/components/AnimatedInput";

const PhoneNumber = (props) => (
  <Field name={props?.name}>
    {({ field, meta, form }) => (
       <InputContainer>
          <div className="input-container">
            <PatternFormat
              format="(###) ###-####"
              name={field.name}
              // placeholder={props?.placeholder}
              disabled={props?.disabled}
              type={'tel'}
              onValueChange={(e) => {
                form.setFieldValue(props?.name, e.value);
                props?.onChangeHandler && props?.onChangeHandler(e.value)                
              }}
              className={`${meta.touched && meta.error ? "error" : ""}`}
              {...field}
            />
              <label className={field.value && 'filled'} htmlFor={props?.name}>
                {props?.placeholder}
              </label>
            {meta.touched && meta.error && !props?.disabled && (
              <p name={props?.name + "Error"} className="error-message">{meta.error}</p>
            )}
          </div>
      </InputContainer>
    )}
  </Field>
);

export default PhoneNumber;
